<app-navtop></app-navtop>
<app-navside-apps-list></app-navside-apps-list>
<app-navside-sponsor></app-navside-sponsor>

<div class="container pt-5">
  <div class="d-flex flex-row bd-highlight">
    <div class="col-lg-6 col-md-8 p-2 mx-xl-auto mx-lg-auto ml-md-auto content-main">
      <div class="card my-3"  *ngFor="let handicraftDoc of handicraftCol | async">
        <div class="list-group my-1">
          <a class="list-group-item list-group-flush border-0">                
            <div class="media">                        
              <img [src]="handicraftDoc.ownerProfilePictureUrl" class="mr-3 align-self-center rounded-circle image" alt="...">
              <div class="media-body">
                <h3>{{handicraftDoc.ownerName}}</h3>
                <p>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-fill text-success" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"/>
                  </svg>
                  +(675)-{{handicraftDoc.ownerPhone}}
                </p>
              </div>
            </div>               
          </a>   
        </div>           
        <img [src]="handicraftDoc.pictureUrl" class="card-img-top">
        <div class="card-body">
          <small class="text-muted font-italic">{{handicraftDoc.dateCreated | date}}</small>
          <p class="font-weight-bold">{{handicraftDoc.name}}</p>
          <p>{{handicraftDoc.price | currency:'K'}}</p>
          <p>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-geo-alt-fill" viewBox="0 0 16 16">
              <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"/>
            </svg>
            {{handicraftDoc.ownerLocation}}
          </p> 
          <a (click)="routeHandicraftDetailPage(handicraftDoc.id)" routerLink="" class="btn btn-dark text-white my-1 stretched-link">View Details...</a>
        </div>
      </div>
    </div>
  </div>
</div>
